import Section from "./ui/Section";

export default function Contact() {
  return (
    <Section id="contact" className="bg-white dark:bg-[#0a0a0a]">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl font-bold text-[#1a1a1a] dark:text-white mb-12">
          Get in Touch
        </h2>

        <div className="grid md:grid-cols-2 gap-6">
          <a
            href="mailto:contact@caratpay.co.in"
            className="flex flex-col items-center justify-center gap-4 bg-[#fdfaf2] dark:bg-[#111] p-10 rounded-3xl border border-[#C9A227]/10 hover:border-[#C9A227] transition-all group"
          >
            <div className="w-12 h-12 bg-white dark:bg-[#0a0a0a] rounded-full flex items-center justify-center text-[#6b5a1a] dark:text-[#C9A227] shadow-sm group-hover:scale-110 transition-transform">
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <title>Email</title>
                <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <div>
              <div className="text-sm text-gray-500 uppercase tracking-wider font-semibold mb-1">
                Email Us
              </div>
              <div className="text-xl font-bold text-[#1a1a1a] dark:text-white">
                contact@caratpay.co.in
              </div>
            </div>
          </a>

          <div className="flex flex-col items-center justify-center gap-4 bg-[#fdfaf2] dark:bg-[#111] p-10 rounded-3xl border border-[#C9A227]/10 hover:border-[#C9A227] transition-all group cursor-default">
            <div className="w-12 h-12 bg-white dark:bg-[#0a0a0a] rounded-full flex items-center justify-center text-[#6b5a1a] dark:text-[#C9A227] shadow-sm group-hover:scale-110 transition-transform">
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <title>Visit us</title>
                <path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            </div>
            <div>
              <div className="text-sm text-gray-500 uppercase tracking-wider font-semibold mb-1">
                Visit Us
              </div>
              <div className="text-xl font-bold text-[#1a1a1a] dark:text-white">
                Bangalore, India
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
}
